<template>
  <div>
    <!-- <div class="container">
      <div class="progres">
        <div class="percen"></div>
      </div>
      <div class="step">
        <div class="ste" id="0"></div>
        <div class="ste" id="1"></div>
        <div class="ste" id="2"></div>
      </div>
    </div> -->

    <div class="px-3">
      <input type="range" :min="low" :max="high" :value="price" disabled />
    </div>
  </div>
</template>
<script>
export default {
  name: "ProgressBar52",
  props: {
    low: {
      type: Number,
      required: true,
    },
    high: {
      type: Number,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    progress(stepNum) {
      let els = document.getElementsByClassName("ste");
      let steps = [];
      Array.prototype.forEach.call(els, (e) => {
        steps.push(e);
      });
      let p = stepNum * 25;
      document.getElementsByClassName("percen")[0].style.width = `${p}%`;
      steps.forEach((e) => {
        if (e.id === stepNum) {
          // e.classList.add("selecte");
          e.classList.remove("complete");
        }
        if (e.id < stepNum) {
          e.classList.add("complete");
          // e.classList.add("selecte");
        }
        if (e.id > stepNum) {
          e.classList.remove("selecte", "complete");
        }
      });
    },
    loadActive() {
      if (this.price > this.low && this.price < this.high) {
        this.progress("2");
      } else if (this.price > this.low && this.price >= this.high) {
        this.progress("4");
      } else if (this.price <= this.low) {
        this.progress("0");
      }
    },
  },
  mounted() {
    // this.loadActive();
    // this.progress("3");
  },
};
</script>
<style scoped>
/*
  progress bar stepper
  */
.container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.step {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 103%;
}
.ste {
  width: 10px;
  height: 10px;
  background: #fff;
  border: 2px solid #acaca6;
  border-radius: 50%;
  transition: background 1s;
}
.ste.selecte {
  border: 2px solid #2d8cff;
}
.ste.complete {
  border: 2px solid #2d8cff;
  background: #2d8cff;
}
.progres {
  position: absolute;
  top: 0px;
  width: 95%;
  height: 50%;
  border-bottom: 2px solid #acaca6;
  z-index: -1;
}
.percen {
  position: absolute;
  top: 1.5px;
  width: 0;
  height: 100%;
  border-bottom: 2px solid #2d8cff;
  z-index: 1;
  transition: width 1s;
}

/*
range slider
*/
input[type="range"] {
  font-size: 1.5rem;
  width: 100%;
}

input[type="range"] {
  color: #2d8cff;
  --thumb-height: 0.7em;
  --track-height: 0.125em;
  --track-color: rgba(0, 0, 0, 0.2);
  --brightness-hover: 180%;
  --brightness-down: 80%;
  --clip-edges: 0.125em;
}
/* === range commons === */
input[type="range"] {
  position: relative;
  background: #fff0;
  overflow: hidden;
}

/*input[type="range"]:disabled {
  filter: grayscale(1);
  opacity: 0.3;
  cursor: not-allowed;
}*/

/* === WebKit specific styles === */
input[type="range"],
input[type="range"]::-webkit-slider-runnable-track,
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  transition: all ease 100ms;
  height: var(--thumb-height);
}

input[type="range"]::-webkit-slider-runnable-track,
input[type="range"]::-webkit-slider-thumb {
  position: relative;
}

input[type="range"]::-webkit-slider-thumb {
  --thumb-radius: calc((var(--thumb-height) * 0.5) - 1px);
  --clip-top: calc((var(--thumb-height) - var(--track-height)) * 0.5 - 0.5px);
  --clip-bottom: calc(var(--thumb-height) - var(--clip-top));
  --clip-further: calc(100% + 1px);
  --box-fill: calc(-100vmax - var(--thumb-width, var(--thumb-height))) 0 0 100vmax
    currentColor;

  width: var(--thumb-width, var(--thumb-height));
  background: linear-gradient(currentColor 0 0) scroll no-repeat left center / 50%
    calc(var(--track-height) + 1px);
  background-color: currentColor;
  box-shadow: var(--box-fill);
  border-radius: var(--thumb-width, var(--thumb-height));

  filter: brightness(100%);
  clip-path: polygon(
    100% -1px,
    var(--clip-edges) -1px,
    0 var(--clip-top),
    -100vmax var(--clip-top),
    -100vmax var(--clip-bottom),
    0 var(--clip-bottom),
    var(--clip-edges) 100%,
    var(--clip-further) var(--clip-further)
  );
}

input[type="range"]:active::-webkit-slider-thumb {
  filter: brightness(var(--brightness-down));
  cursor: grabbing;
}

input[type="range"]::-webkit-slider-runnable-track {
  background: linear-gradient(var(--track-color) 0 0) scroll no-repeat center / 100%
    calc(var(--track-height) + 1px);
}

/* === Firefox specific styles === */
input[type="range"],
input[type="range"]::-moz-range-track,
input[type="range"]::-moz-range-thumb {
  appearance: none;
  transition: all ease 100ms;
  height: var(--thumb-height);
}

input[type="range"]::-moz-range-track,
input[type="range"]::-moz-range-thumb,
input[type="range"]::-moz-range-progress {
  background: #fff0;
}

input[type="range"]::-moz-range-thumb {
  background: currentColor;
  border: 0;
  width: var(--thumb-width, var(--thumb-height));
  border-radius: var(--thumb-width, var(--thumb-height));
  cursor: grab;
}

input[type="range"]:active::-moz-range-thumb {
  cursor: grabbing;
}

input[type="range"]::-moz-range-track {
  width: 100%;
  background: var(--track-color);
}

input[type="range"]::-moz-range-progress {
  appearance: none;
  background: currentColor;
  transition-delay: 30ms;
}

input[type="range"]::-moz-range-track,
input[type="range"]::-moz-range-progress {
  height: calc(var(--track-height) + 1px);
  border-radius: var(--track-height);
}

input[type="range"]::-moz-range-thumb,
input[type="range"]::-moz-range-progress {
  filter: brightness(100%);
}

input[type="range"]:hover::-moz-range-thumb,
input[type="range"]:hover::-moz-range-progress {
  filter: brightness(var(--brightness-hover));
}

input[type="range"]:active::-moz-range-thumb,
input[type="range"]:active::-moz-range-progress {
  filter: brightness(var(--brightness-down));
}
</style>
